import React from 'react'
import NotAllowContainer from '../../containers/Video/Calling/NotAllowed'

const NotAllowed: React.FC = () => {
  return <NotAllowContainer />
}

export const PATH = '/video/not-allowed' as const
export default NotAllowed
